import { LOCATION_CHANGED } from 'redux-little-router'
import { actionTypes } from '../constants'

const initialState = {
  openMarker: null,
}

const map = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGED:
      // Close markers if we're not in Map view.
      if (action.payload.pathname.indexOf('/map') === -1) {
        return {
          ...state,
          openMarker: null,
        }
      }
      return state
    
    case actionTypes.MAP_WAS_CLICKED:
      return {
        ...state,
        openMarker: null,
      }

    case actionTypes.VENUE_MARKER_WAS_CLICKED:
      if (action.payload._id === state.openMarker) {
        return {
          ...state,
          openMarker: null,
        }
      }
      return {
        ...state,
        openMarker: action.payload._id,
      }

    default:
      return state
  }
}

export default map
